export enum ColorMode {
  Dark = 'dark',
  Light = 'light',
  System = 'system',
}
